import { DataProvider, useMutation, UseMutationOptions } from "@nf/common";

interface IValidatePinCodeVariables {
  pinCodeId?: string;
  pinCode: string;
}

export const useValidatePinCode = (
  options?: UseMutationOptions<void, Error, IValidatePinCodeVariables>
) =>
  useMutation<void, Error, IValidatePinCodeVariables>(
    async ({ pinCodeId, pinCode }) => {
      const isValid = await DataProvider.validateUserSubprofilePinCode(
        pinCodeId,
        pinCode
      );

      if (!isValid) {
        throw new Error("Invalid PIN code");
      }
    },
    options
  );
